import { Shark, Utils, View } from "shark-mvc";

import ContentPack from "../../models/ContentPack";

import templateContent from "./content-pack-list.html";

import contentFinderComponent from "../../components/contentFinder/contentFinderComponent";
import contentPackDetailView from "./contentPackDetailView";
import contentPackManager from "../../controllers/contentPackManager";
import mainNavComponent from "../../components/mainNav/mainNavComponent";
import waitBoxComponent from "../../components/waitBox/waitBoxComponent";
import ContentPackPage from "../../models/ContentPackPage";

class ContentPackListView extends View {
	recentRange = {
		first: 0,
		length: 5,
	};
	
	recentSort = {
		updated_at: "DESC",
	};
	
	constructor () {
		super("contentPackListView");

		this.$mainRoute = "content-pack-list";
		this.setTemplate(templateContent);
	}
	
	addContentPack () {
		const currContentPack = new ContentPack({
			content: {
				mainPage: new ContentPackPage(),
				secondaryPages: [],
			},
			status: 1,
		});

		Shark.set({
			currContentPack,
		});
		Shark.openPage(contentPackDetailView, {urlSearchParams: null});
	}

	addContentPackBtn_clickHandler () {
		this.addContentPack();
	}

	beforeLoad () {
		window.scrollTo(0, 0);

		// contentFinderComponent.on("content_selected", this.contentFinderComponent_content_selectedHandler);

		let currUser = Shark.get("currUser");

		if (currUser) {
			this.refreshRecentContentPackList();
		}

		Shark.set({
			recentContentPackList: [],
		});
	}

	beforeUnload () {
		// contentFinderComponent.resetContentFinderSearchField();
		// contentFinderComponent.off("content_selected", this.contentFinderComponent_content_selectedHandler);
	}

	// contentFinderComponent_content_selectedHandler (event, data) {
	// 	console.log(this, {event, data});
	// 	// contentType: "image"
	// 	// guid: "19e5a587-23fd-48cb-b300-e056a116c293"
	// 	// title: "Le Cime di Lavaredo"
	// 	let contentManager;
	// 	let destView;

	// 	switch (data.contentType) {
	// 		case "image":
	// 			contentManager = imageContentManager;
	// 			destView = imageContentView;
	// 			break;
	// 		case "place":
	// 			contentManager = placeContentManager;
	// 			destView = placeContentView;
	// 			break;
	// 		case "text":
	// 			contentManager = textContentManager;
	// 			destView = textContentView;
	// 			break;
	// 	}

	// 	contentManager.getByGuid(data.guid)
	// 	.then(getByGuidResponse => {
	// 		console.log({getByGuidResponse});
	
	// 		let currContent;

	// 		switch (data.contentType) {
	// 			case "image":
	// 				currContent = new ImageContent(getByGuidResponse.data[0]);
	// 				break;
	// 			case "place":
	// 				currContent = new PlaceContent(getByGuidResponse.data[0]);
	// 				break;
	// 			case "text":
	// 				currContent = new TextContent(getByGuidResponse.data[0]);
	// 				break;
	// 		}
	
	// 		contentFinderComponent.resetContentFinderSearchField();
	// 		Shark.set({
	// 			currContent,
	// 		});

	// 		Shark.openPage(destView, { urlSearchParams: { coguid: currContent.guid} });
	// 	});
	// }

	editContentPack (contentGuid) {
		const currContentPack = Utils.safp(Shark.$store.recentContentPackList, "guid", contentGuid);
		
		if (currContentPack) {
			Shark.set({
				currContentPack,
			});

			console.log({currContentPack});
			Shark.openPage(contentPackDetailView, {urlSearchParams: { copaguid: currContentPack.guid } });
		}
	}

	editContentPackBtn_clickHandler (event, data) {
		if (data.guid) {
			this.editContentPack(data.guid);
		}
	}

	init () {
		this.addComponents([contentFinderComponent, mainNavComponent, waitBoxComponent]);

		Shark.set({
			recentContentPackList: [],
		});
	}

	refreshRecentContentPackList () {
		contentPackManager.getList({ range: this.recentRange, sort: this.recentSort })
		.then(response => {
			const recentContentPackList = Shark.getInstanceList(ContentPack, response.data);
			this.updateRecentContentList(recentContentPackList);
		});
	}

	updateRecentContentList (contentPackListToAdd) {
		const recentContentPackList = [...Shark.$store.recentContentPackList, ...contentPackListToAdd];

		recentContentPackList.sort((a, b) => {
			if (a.updatedAt > b.updatedAt) {
				return -1;
			}
			else if (a.updatedAt < b.updatedAt) {
				return 1;
			}
		});

		Shark.set({
			recentContentPackList,
		});
	}
}

const contentPackListView = new ContentPackListView();

Shark.registerView(contentPackListView);

export default contentPackListView;
